import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

const OurMission = () => {
    useGSAP(() => {
        gsap.from('#mission', {
            scrollTrigger: {
                trigger: '#mission'
            },
            duration: 1,
            opacity: 0,
            y: 130,
            stagger: 0.3
        });
    }, []);

    return (
        <div id="mission" className="md:w-[calc((100%/3)-30px)] w-full p-3 rounded-lg">
            <h2 className="mb-3 text-[24px] font-bold">Our Mission</h2>
            <p className="leading-[30px]">To empower and support women's access to human rights, health, and safety through community led initiatives, advocacy, and education. Creating an inclusive and non-judgmental environment</p>
        </div>
    );
}

export default OurMission;